'use strict';

const formValidation = require('core/components/formValidation');
const clientSideValidation = require('core/components/clientSideValidation');
const addToCartValidation = require('core/product/addToCartValidation');
const recaptcha = require('core/components/recaptcha');
const $body = $('body');

const NOTIFY_ME_SHEET_IDS = ['notify-me-sheet', 'notify-me-mm6-sheet'];

module.exports = {
  init: function () {
    clientSideValidation.init();
    initNotifyReCaptcha();

    $body.on('click', '.js-sheet-close-cta', function () {
        var $activeSheet = $(this).closest('.mm-sheet');
        $activeSheet.find('.js-sheet-close').click();
    });

    $body.on('change', '#newsletter-signup-notify-me', function () {
      const isChecked = $(this).is(':checked');
      const $wrapper = $('.js-collection-wrapper');
      const $acceptMsg = $('.js-notifyme-acceptnewsletters');
      if (isChecked) {
        $wrapper.removeClass('d-none');
        $acceptMsg.removeClass('d-none');
        $wrapper.find('input[type="radio"]').prop('disabled', false);
      } else {
        $wrapper.addClass('d-none');
        $acceptMsg.addClass('d-none');
        $wrapper.find('input[type="radio"]').prop('disabled', true);
      }
    });

    $body.on('input change', '.js-input-notify-me-email, #privacy-notify-me', function () {
      const $form = $(this).closest('.js-mm-notify-when-available');
      updateSubmitButtonState($form);
    });

    $body.on('submit', '.js-mm-notify-when-available', function (e) {
      const $form = $(this);
      e.preventDefault();
      $.spinner().start();
      clientSideValidation.functions.clearFormErrors($form);
      $('.product-notify-content .success-message').removeClass('success');

      if(!$form.find('[type="checkbox"][required="required"]').prop('checked')) {
        $form.find('[type="checkbox"][required="required"]').addClass('-invalid');
        return;
      }

      // Check if all variation attribute selected
      let $productContainer = $(this).closest('.product-detail');
      if (addToCartValidation($productContainer)) {
        $.post({
          url: $form.attr('action'),
          dataType: 'json',
          data: $form.serialize(),
          success: function (data) {
            if (!data.success) {
              formValidation($form, data);
              if(Object.keys(data.fields).length === 0 && data.message.length > 0) {
                cleanSheetShowMsg(data.message);
              }
            } else {
              cleanSheetShowMsg(data.message);
              //Tealium trigger "Back In Stock"
              $('body').trigger('product:afterBackInStock');
              $('body').trigger('product:backInStockComplete');
            };
          },
          complete: function () {
            $.spinner().stop();
          },
        });
      } else {
        $.spinner().stop();
      }

      return false;
    });
  },
  updateForm: function () {
    $('body').on('product:updateAvailability', function (e, response) {
      var $container;

      $container = $('.product-notify .product-notify-sheet-content');
      if ($container.length > 0) {
        $container.empty().append(response.product.notifyWhenAvailableHtml);
        const $form = $container.find('.js-mm-notify-when-available');
        if ($form.length) {
          updateSubmitButtonState($form);
        }
      }

      initNotifyReCaptcha();
    });
  },
  // Tealium: "Notify Me" start/complete tracking (pdp_backinstock_start / pdp_backinstock_complete)
  trackTealiumEvents: function () {
    document.addEventListener('MMSheet:opening', function (e) {
      if (!utagExists()) return;
      const el = e.detail && e.detail.element;
      if (!el || NOTIFY_ME_SHEET_IDS.indexOf(el.id) === -1) return;

      utag.data.event_name = 'pdp_backinstock_start';
      utag.link(utag.data);
    });

    $body.on('product:backInStockComplete', function () {
      if (!utagExists()) return;

      utag.data.event_name = 'pdp_backinstock_complete';
      utag.link(utag.data);
    });
  },
};

function utagExists() {
  return typeof utag !== 'undefined';
}

function cleanSheetShowMsg(message) {
    $('.product-notify-content .success-message').addClass('success');
    $('.notify-me-container').empty().append('<span class="success-msg">' + message + '</span>');
    $('.js-sheet-close-cta').removeClass('d-none');
}

function initNotifyReCaptcha() {
  let siteKey = $('#recaptchaSitekey').length > 0 ? $('#recaptchaSitekey').val() : null;
  if ($('#gReCaptchaWidgetNotify').length > 0 && siteKey) {
    recaptcha.loadReCaptcha(siteKey).then(function() {
      grecaptcha.ready(function() {
        grecaptcha.execute(siteKey, { action: 'init' }).then(function(token) {
          $('#gReCaptchaWidgetNotify').val(token);
        });
      });
    });
  }
}

function updateSubmitButtonState($form) {
  const emailInput = $form.find('.js-input-notify-me-email')[0];
  const privacyCheckbox = $form.find('#privacy-notify-me');
  const submitButton = $form.find('button[type="submit"]');

  if (emailInput && privacyCheckbox.length && submitButton.length) {
    const isEmailValid = emailInput.checkValidity();
    const isPrivacyChecked = privacyCheckbox.is(':checked');
    submitButton.prop('disabled', !(isEmailValid && isPrivacyChecked));
  }
}
